import React from 'react';
import { motion } from 'framer-motion';
import { RevealText } from './common/RevealText';
import Container from './common/Container';
import { ShieldCheck, Clock, PenTool, Users } from 'lucide-react';

const Services = () => {
    const services = [
        {
            icon: <ShieldCheck size={40} />,
            title: "Premium Quality",
            description: "We use only the highest grade materials to ensure your home stands the test of time."
        },
        {
            icon: <Clock size={40} />,
            title: "Timely Delivery",
            description: "We respect your time and strictly adhere to project timelines and delivery schedules."
        },
        {
            icon: <PenTool size={40} />,
            title: "Modern Design",
            description: "Our architectural designs blend contemporary aesthetics with functional living spaces."
        },
        {
            icon: <Users size={40} />,
            title: "Transparent Dealings",
            description: "Honesty and transparency are at the core of our interactions with every stakeholder."
        }
    ];

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.8,
                ease: [0.22, 1, 0.36, 1]
            }
        }
    };

    return (
        <section className="py-10 md:py-12 lg:py-16  bg-white relative overflow-hidden">
            {/* Background Decor */}
            <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-secondary/5 rounded-full blur-[100px] pointer-events-none -translate-y-1/2 translate-x-1/2" />

            <Container className="relative z-10">
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                >
                    <div className="text-center mb-16">
                        <motion.span
                            variants={itemVariants}
                            className="text-secondary font-bold tracking-wider uppercase text-sm"
                        >
                            Why Choose Us
                        </motion.span>
                        <motion.h2
                            variants={itemVariants}
                            className="mt-2 text-3xl md:text-5xl font-serif text-primary font-bold"
                        >
                            <RevealText className='justify-center pb-2' text="Excellence in Every Detail" />
                        </motion.h2>
                        {/* <motion.p
                            variants={itemVariants}
                            className="mt-4 text-light max-w-2xl mx-auto text-lg"
                        >
                            We don't just build structures; we create homes where memories are made.
                        </motion.p> */}
                        <div className="mt-4 mx-auto w-24 h-1 bg-secondary" style={{ width: "96px" }}></div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {services.map((service, index) => (
                            <motion.div
                                key={index}
                                variants={itemVariants}
                                whileHover={{ y: -10 }}
                                className="justify-center items-center flex flex-col md:items-start group md:p-6 p-4 lg:p-8 bg-surface rounded-lg border border-gray-100 shadow-sm hover:shadow-xl hover:border-secondary/30 transition-all duration-300"
                            >
                                <div className="mb-4 lg:mb-6  text-secondary group-hover:scale-110 transition-transform duration-300">
                                    {service.icon}
                                </div>
                                <h3 className="mb-2 lg:mb-3 text-md md:text-lg lg:text-xl  font-bold text-primary transition-colors">
                                    {service.title}
                                </h3>
                                <p className="text-secondary leading-relaxed text-sm md:text-md lg:text-lg">
                                    {service.description}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </Container>
        </section>
    );
};

export default Services;
